export default __webpack_public_path__ + "static/eKYC-portal-for-hotel-check-ins-1aa374e4b11262f69fc8118ebbcfbdf9.png";